import React, { useId } from 'react';
import { Circle } from 'react-native-svg';
import { IconWithGradient } from './Icon';
export const IconDots = (props) => {
    const id = useId();
    return (<IconWithGradient id={id} {...props} defaultGradientKey="darkPurple">
      <Circle cx="4" cy="12" r="2" fill={`url(#gradient_${id})`}/>
      <Circle cx="12" cy="12" r="2" fill={`url(#gradient_${id})`}/>
      <Circle cx="20" cy="12" r="2" fill={`url(#gradient_${id})`}/>
    </IconWithGradient>);
};
